export default __webpack_public_path__ + "static/media/image-094.d39b368f.jpeg";